import React from "react";

export const ProgressContext = React.createContext({});